<template>
  <div :class="this.$store.state.search.searchFlag ? 'quick-search show' : 'quick-search'">
    <Hamburger v-on:show-modal="hideSection" classes="hamburger-container close"/>

    <SearchForm v-on:search-term-update="searchTermUpdate" :focus="searchActive"/>

    <p class="large title" v-if="query.length == 0">Please enter a term to start searching</p>

    <div class="information" v-if="query.length > 0">
      <AlgoliaIndex
        :app-id="algoliaAppId"
        :api-key="algoliaApiKey"
        :index-name="algoliaProductsIndexName"
        :query-parameters="{query: query}"
        :auto-search="false"
      >
        <AlgoliaStats>
          <template slot-scope="{ totalResults, query }">
            <a :href="'/search?q=' + query">
              See {{ totalResults == 1 ? '' : 'all' }}
              <span>{{ totalResults }} product{{ totalResults == 1 ? '' : 's' }}</span> matching
              <span>‘{{ query }}’</span>
              <IconBase icon-name="cart" width="14px" height="14px" view-box="0 0 14 14">
                <ArrowIcon/>
              </IconBase>
            </a>
          </template>
        </AlgoliaStats>
      </AlgoliaIndex>
    </div>

    <AlgoliaIndex
      :app-id="algoliaAppId"
      :api-key="algoliaApiKey"
      :index-name="algoliaProductsIndexName"
      :query-parameters="{query: query}"
      :auto-search="false"
      v-if="query.length > 0"
    >
      <AlgoliaStats>
        <template slot-scope="{ totalResults, query }">
          <div class="quick-search__results" v-if="query.length > 0 && totalResults > 0">
            <div class="quick-search__results-title">PRODUCTS</div>
            <AlgoliaResults :results-per-page="4">
              <template slot-scope="{ result }">
                <SearchCardProduct :product="result"/>
              </template>
            </AlgoliaResults>
          </div>
        </template>
      </AlgoliaStats>
    </AlgoliaIndex>

    <hr v-if="query.length > 1">

    <AlgoliaIndex
      :app-id="algoliaAppId"
      :api-key="algoliaApiKey"
      :index-name="algoliaCollectionsIndexName"
      :query-parameters="{query: query}"
      :auto-search="false"
      v-if="query.length > 0"
    >
      <AlgoliaStats>
        <template slot-scope="{ totalResults, query }">
          <div class="quick-search__results" v-if="query.length > 0 && totalResults > 0">
            <div class="quick-search__results-title">COLLECTIONS</div>
            <AlgoliaResults :results-per-page="2">
              <template slot-scope="{ result }">
                <a :href="'/collections/' + result.handle" class="search-result">
                  <AlgoliaHighlight :result="result" attribute-name="title"></AlgoliaHighlight>
                </a>
              </template>
            </AlgoliaResults>
          </div>
        </template>
      </AlgoliaStats>
    </AlgoliaIndex>
  </div>
</template>

<script>
import SearchCardProduct from './SearchCardProduct.vue'
import IconBase from '../atoms/IconBase.vue'
import ArrowIcon from '../atoms/ArrowIcon.vue'
import SearchIcon from '../atoms/SearchIcon.vue'
import Hamburger from '../atoms/Hamburger.vue'
import SearchForm from '../atoms/SearchForm.vue'
import { mapGetters } from 'vuex'

import {
  Index as AlgoliaIndex,
  Results as AlgoliaResults,
  SearchBox as AlgoliaSearchBox,
  Stats as AlgoliaStats,
  Highlight as AlgoliaHighlight,
} from 'vue-instantsearch'

export default {
  data: function() {
    return {
      query: '',
      algoliaAppId: ALGOLIA_APP_ID,
      algoliaApiKey: ALGOLIA_API_KEY,
      algoliaProductsIndexName: ALGOLIA_PREFIX + '_products',
      algoliaCollectionsIndexName: ALGOLIA_PREFIX + '_collections',
    }
  },
  components: {
    AlgoliaIndex,
    AlgoliaResults,
    AlgoliaSearchBox,
    AlgoliaStats,
    AlgoliaHighlight,
    SearchCardProduct,
    Hamburger,
    IconBase,
    ArrowIcon,
    SearchIcon,
    SearchForm,
  },
  props: {
    isShowSearch: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['searchActive']),
  },
  methods: {
    hideSection: function() {
      this.$store.commit('showSearch')
      return this.$store.state.search.searchFlag
    },
    searchTermUpdate: function(term) {
      this.query = term
    },
  },
}
</script>
